import { UserUiStateKey } from "@models";

export const UPGRADE_PLAN_TOOLTIP =
  "Upgrade to a paid plan to enable those functionalities";

export const WELCOME_MODAL_KEY: UserUiStateKey = "welcomeSeen";
export const DEMO_COMPLETE_MODAL_KEY: UserUiStateKey = "demoCompleteModalSeen";
